<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./Benefits.translations.json";
	import Link from "./Link.svelte";
	import imgBenefit1 from "../../../core/assets/images/benefit1.png?webp&w=393&imagetools";
	import imgBenefit2 from "../../../core/assets/images/benefit2.png?webp&w=393&imagetools";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import imgBenefit3 from "../../../core/assets/images/new-post.png?webp&w=393&imagetools";

	const translate = getTranslate(translations);

	export let takeTheAdvantageHeadline = "";
	export let href = "#";

	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="container py-32">
	<div class="flex flex-col gap-14 lg:flex-row lg:gap-28">
		<div class="mx-auto max-w-5xl">
			<h2 class="text-md mb-16 text-center lg:text-lg">{@html takeTheAdvantageHeadline}</h2>
		</div>
	</div>

	<div class="flex flex-col items-center justify-center gap-6 lg:flex-row lg:flex-wrap lg:items-stretch">
		<div class="flex min-h-96 min-w-[23.68rem] max-w-[23.68rem] flex-col rounded-lg bg-[#202020] p-8">
			<div class="min-h-[12.68rem]">
				<p class="text-2xs text-center font-bold text-white">{translate("question1")}</p>
				<p class="text-2xs mb-0 text-center font-medium text-white">{translate("answer1")}</p>
			</div>
			<div>
				<StaticPicture width={393} height={195} image={imgBenefit1} alt="benefits" class="mt-4" />
			</div>
		</div>
		<div class="flex min-h-96 min-w-[23.68rem] max-w-[23.68rem] flex-col rounded-lg bg-[#202020] p-8">
			<div class="min-h-[12.68rem]">
				<p class="text-2xs text-center font-bold text-white">{translate("question2")}</p>
				<p class="text-2xs mb-0 text-center font-medium text-white">{translate("answer2")}</p>
			</div>
			<div><StaticPicture width={393} height={195} image={imgBenefit2} alt="benefits" class="mt-4" /></div>
		</div>
		<div class="flex min-h-96 min-w-[23.68rem] max-w-[23.68rem] flex-col rounded-lg bg-[#202020] p-8">
			<div class="min-h-[12.68rem]">
				<p class="text-2xs text-center font-bold text-white">{translate("question3")}</p>
				<p class="text-2xs mb-0 text-center font-medium text-white">{translate("answer3")}</p>
			</div>
			<div>
				<StaticPicture width={393} height={195} image={imgBenefit3} alt="benefits" class="mt-4" />
			</div>
		</div>
	</div>

	<Link variant="tertiary" asButton {href} class="mx-auto mt-12">
		{translate("tryApp")}
	</Link>
</div>
